//Node imports
import { IEvent } from "@quest/adapter-interface";
import { Bitmap, Container, ITween, Linear, dispatcher, ingenuity } from "@quest/base-core";
import { BlurBackgroundController } from "@quest/murka-games-behavior-leopard/dist";

//Class imports
import { eventDispatchers } from "../Constants/EventDispatchers";
import { gameConstants } from "../Constants/gameConstants";

export class BlurBackgroundControllerGame extends BlurBackgroundController {
    private bigWinBlurContainer: Container;
    private freeGameIntroBlurContainer: Container;
    private freeGameOutroBlurContainer: Container;
    private grandJackpotBlurContainer: Container;
    private majorJackpotBlurContainer: Container;
    private minorJackpotBlurContainer: Container;
    private miniJackpotBlurContainer: Container;
    private retriggerBlurContainer: Container;
    private blurBgFadeInDuration: number = 500;
    private blurBgFadeOutDuration: number = 300;


    /**
    * Override initializeElements to initialize blur background elements
    */
    protected initializeElements(): void {
        super.initializeElements();
        const blur1: any = (ingenuity.currentGame as any).add.filter("Blur");
        blur1.blurY = 10;
        this.view.getImageById("gameIntroBlurBg").filters = [blur1];
        this.bigWinBlurContainer = this.view.getContainerByID("bigWinBlurContainer");
        this.freeGameIntroBlurContainer = this.view.getContainerByID("freeGameIntroBlurContainer");
        this.freeGameOutroBlurContainer = this.view.getContainerByID("freeGameOutroBlurContainer");
        this.grandJackpotBlurContainer = this.view.getContainerByID("grandJackpotBlurContainer");
        this.majorJackpotBlurContainer = this.view.getContainerByID("majorJackpotBlurContainer");
        this.minorJackpotBlurContainer = this.view.getContainerByID("minorJackpotBlurContainer");
        this.miniJackpotBlurContainer = this.view.getContainerByID("miniJackpotBlurContainer");
        this.retriggerBlurContainer = this.view.getContainerByID("retriggerBlurContainer");
    }

    /**
    * Override subscribeEvents to subscribe blur background events
    */
    protected subscribeEvents(): void {
        super.subscribeEvents()
        dispatcher.on(eventDispatchers.SHOW_BLUR_BACKGROUND, this.showBlurBackground, this);
        dispatcher.on(eventDispatchers.HIDE_BLUR_BACKGROUND, this.hideBlurBackground, this);
            dispatcher.on(
      eventDispatchers.SHOW_POP_UP_BLUR_BG,
      this.showPopUpBlurBg,
      this
    );
    dispatcher.on(
      eventDispatchers.HIDE_POP_UP_BLUR_BG,
      this.hideBlurBgWithFadeOutEffect,
      this
    );
    }
    
    /**
    * Override unsubscribeEvents to unsubscribe blur background events
    */
    protected unsubscribeEvents(): void {
        super.unsubscribeEvents();
        dispatcher.off(eventDispatchers.SHOW_BLUR_BACKGROUND, this.showBlurBackground, this);
        dispatcher.off(eventDispatchers.HIDE_BLUR_BACKGROUND, this.hideBlurBackground, this);
            dispatcher.off(
      eventDispatchers.SHOW_POP_UP_BLUR_BG,
      this.showPopUpBlurBg,
      this
    );
    dispatcher.off(
      eventDispatchers.HIDE_POP_UP_BLUR_BG,
      this.hideBlurBgWithFadeOutEffect,
      this
    );
    }

  // Add to show Big win, Fg Intro & Outro blur background
  private showPopUpBlurBg(evt: IEvent): void {
    const superWinBlurBg: Bitmap = this.view.getImageById("superWinBlurBg");
    const bigWinBlurBg: Bitmap = this.view.getImageById("bigWinBlurBg");
    const epicWinBlurBg: Bitmap = this.view.getImageById("epicWinBlurBg");
    const crazyWinBlurBg: Bitmap = this.view.getImageById("crazyWinBlurBg");
    switch (evt.data) {
      case gameConstants.SHOW_BIG_WIN_BLUR_BG:
        if(!bigWinBlurBg.visible)
          this.showBlurBgWithFadeInEffect(bigWinBlurBg, this.hideBgCallBack, []);
        break;
      case gameConstants.SHOW_SUPER_WIN_BLUR_BG:
        if(!superWinBlurBg.visible)
          this.showBlurBgWithFadeInEffect(superWinBlurBg, this.hideBgCallBack, [bigWinBlurBg]);
        break;
      case gameConstants.SHOW_EPIC_WIN_BLUR_BG:
        if(!epicWinBlurBg.visible)
          this.showBlurBgWithFadeInEffect(epicWinBlurBg, this.hideBgCallBack, [bigWinBlurBg, superWinBlurBg]);
        break;
      case gameConstants.SHOW_CRAZY_WIN_BLUR_BG:
        if(!crazyWinBlurBg.visible)
          this.showBlurBgWithFadeInEffect(crazyWinBlurBg, this.hideBgCallBack, [bigWinBlurBg, superWinBlurBg, epicWinBlurBg]);
        break;
    }
  }


    /**
    * Method showBlurBackground to show blur background
    */
    protected showBlurBackground(evt: IEvent): void {
        switch (evt.data) {
            case eventDispatchers.SHOW_FG_INTRO_BLUR_BG:
                this.showFGIntroBG();
                break;
            case eventDispatchers.SHOW_FG_OUTRO_BLUR_BG:
                this.showFGOutroBG();
                break;
            case eventDispatchers.SHOW_GRAND_BLUR_BG:
                this.showGrandJPBG();
                break;
            case eventDispatchers.SHOW_MAJOR_BLUR_BG:
                this.showMajorJPBG();
                break;
            case eventDispatchers.SHOW_MINOR_BLUR_BG:
                this.showMinorJPBG();
                break;
            case eventDispatchers.SHOW_MINI_BLUR_BG:
                this.showMiniJPBG();
                break;
            case eventDispatchers.SHOW_RETRIGGER_BLUR_BG:
                this.showRetriggerBG();
                break;
        }
    }
  /**
   * TO hide background on callbackground showBlurBgWithFadeInEffect method.
   * @param backgrounds 
   * @returns 
   */
  private hideBgCallBack(backgrounds: Bitmap[]): void{
    if(!backgrounds.length) return
    backgrounds.forEach((background:Bitmap)=>{
      background.visible = false;
    },this);
  }

    // Show Blur Background with fade in effect
  private showBlurBgWithFadeInEffect(background: Bitmap, hideBgCallBack:Function, hideBGArray: Bitmap[]): void {
    const popUpBlurBgContainer: Container = this.view.getContainerByID("popUpBlurBgContainer");
    popUpBlurBgContainer.alpha = 1;
    background.alpha = 0;
    background.visible = true;
    const BlurBgFadeInTween: ITween = ingenuity.currentGame.add.tween(background).to({ alpha: 1 },this.blurBgFadeInDuration,Linear.None,true,0,0,false );
    BlurBgFadeInTween.onComplete.addOnce(() => {
      BlurBgFadeInTween.stop();
      ingenuity.currentGame.tweens.remove(BlurBgFadeInTween);
      hideBgCallBack(hideBGArray);
    }, this);
  }
    // /**
    // * Method showBigWinBG to show big win blur background
    // */
    // private showBigWinBG(): void {
    //     this.bigWinBlurContainer.alpha = 0;
    //     this.bigWinBlurContainer.visible = true;
    //     const fadeInEffect1: ITween = ingenuity.currentGame.add.tween(this.bigWinBlurContainer).to({ alpha: 1 }, 300, Linear.None, true, 0, 0, false);
    //     fadeInEffect1.onComplete.addOnce(() => {
    //         fadeInEffect1.stop();
    //         ingenuity.currentGame.tweens.remove(fadeInEffect1);

    //     }, this);
    // }

    /**
    * Method showFGIntroBG to show FG intro blur background
    */
    private showFGIntroBG(): void {
        this.freeGameIntroBlurContainer.alpha = 0;
        this.freeGameIntroBlurContainer.visible = true;
        const fadeInEffect2: ITween = ingenuity.currentGame.add.tween(this.freeGameIntroBlurContainer).to({ alpha: 1 }, 300, Linear.None, true, 0, 0, false);
        fadeInEffect2.onComplete.addOnce(() => {
            fadeInEffect2.stop();
            ingenuity.currentGame.tweens.remove(fadeInEffect2);
        }, this);
    }

    /**
    * Method showFGOutroBG to show FG outro blur background
    */
    private showFGOutroBG(): void {
        this.freeGameOutroBlurContainer.alpha = 0;
        this.freeGameOutroBlurContainer.visible = true;
        const fadeInEffect3: ITween = ingenuity.currentGame.add.tween(this.freeGameOutroBlurContainer).to({ alpha: 1 }, 300, Linear.None, true, 0, 0, false);
        fadeInEffect3.onComplete.addOnce(() => {
            fadeInEffect3.stop();
            ingenuity.currentGame.tweens.remove(fadeInEffect3);
        }, this);
    }

    /**
    * Method showGrandJPBG to show grand jackpot banner blur background
    */
    private showGrandJPBG(): void {
        this.grandJackpotBlurContainer.alpha = 0;
        this.grandJackpotBlurContainer.visible = true;
        const fadeInEffect4: ITween = ingenuity.currentGame.add.tween(this.grandJackpotBlurContainer).to({ alpha: 1 }, 300, Linear.None, true, 0, 0, false);
        fadeInEffect4.onComplete.addOnce(() => {
            fadeInEffect4.stop();
            ingenuity.currentGame.tweens.remove(fadeInEffect4);
        }, this);
    }

    /**
    * Method showMajorJPBG to show major jackpot banner blur background
    */
    private showMajorJPBG(): void {
        this.majorJackpotBlurContainer.alpha = 0;
        this.majorJackpotBlurContainer.visible = true;
        const fadeInEffect5: ITween = ingenuity.currentGame.add.tween(this.majorJackpotBlurContainer).to({ alpha: 1 }, 300, Linear.None, true, 0, 0, false);
        fadeInEffect5.onComplete.addOnce(() => {
            fadeInEffect5.stop();
            ingenuity.currentGame.tweens.remove(fadeInEffect5);
        }, this);
    }

    /**
    * Method showMinorJPBG to show minor jackpot banner blur background
    */
    private showMinorJPBG(): void {
        this.minorJackpotBlurContainer.alpha = 0;
        this.minorJackpotBlurContainer.visible = true;
        const fadeInEffect6: ITween = ingenuity.currentGame.add.tween(this.minorJackpotBlurContainer).to({ alpha: 1 }, 300, Linear.None, true, 0, 0, false);
        fadeInEffect6.onComplete.addOnce(() => {
            fadeInEffect6.stop();
            ingenuity.currentGame.tweens.remove(fadeInEffect6);
        }, this);
    }

    /**
    * Method showMiniJPBG to show mini jackpot banner blur background
    */
    private showMiniJPBG(): void {
        this.miniJackpotBlurContainer.alpha = 0;
        this.miniJackpotBlurContainer.visible = true;
        const fadeInEffect7: ITween = ingenuity.currentGame.add.tween(this.miniJackpotBlurContainer).to({ alpha: 1 }, 300, Linear.None, true, 0, 0, false);
        fadeInEffect7.onComplete.addOnce(() => {
            fadeInEffect7.stop();
            ingenuity.currentGame.tweens.remove(fadeInEffect7);
        }, this);
    }

    /**
    * Method showRetriggerBG to show retrigger banner blur background
    */
    private showRetriggerBG(): void {
        this.retriggerBlurContainer.alpha = 0;
        this.retriggerBlurContainer.visible = true;
        const fadeInEffect8: ITween = ingenuity.currentGame.add.tween(this.retriggerBlurContainer).to({ alpha: 1 }, 300, Linear.None, true, 0, 0, false);
        fadeInEffect8.onComplete.addOnce(() => {
            fadeInEffect8.stop();
            ingenuity.currentGame.tweens.remove(fadeInEffect8);
        }, this);
    }

    /**
    * Method hideBlurBackground to hide blur background
    */
    protected hideBlurBackground(evt: IEvent): void {
        switch (evt.data) {
            case eventDispatchers.HIDE_BIGWIN_BLUR_BG:
                this.hideBigWinBG()
                break;
            case eventDispatchers.HIDE_FG_INTRO_BLUR_BG:
                this.hideFGIntroBG();
                break;
            case eventDispatchers.HIDE_FG_OUTRO_BLUR_BG:
                this.hideFGOutroBG();
                break;
            case eventDispatchers.HIDE_GRAND_BLUR_BG:
                this.hideGrandJPBG();
                break;
            case eventDispatchers.HIDE_MAJOR_BLUR_BG:
                this.hideMajorJPBG();
                break;
            case eventDispatchers.HIDE_MINOR_BLUR_BG:
                this.hideMinorJPBG();
                break;
            case eventDispatchers.HIDE_MINI_BLUR_BG:
                this.hideMiniJPBG();
                break;
            case eventDispatchers.HIDE_RETRIGGER_BLUR_BG:
                this.hideRetriggerBG();
                break;
        }
    }

    /**
    * Method hideBigWinBG to hide bigwin blur background
    */
    private hideBigWinBG(): void{
        const fadeOutEffect1: ITween = ingenuity.currentGame.add.tween(this.bigWinBlurContainer).to({ alpha: 0 }, 300, Linear.None, true, 0, 0, false);
        fadeOutEffect1.onComplete.addOnce(() => {
        this.bigWinBlurContainer.visible = false;
        this.bigWinBlurContainer.alpha = 1;
            fadeOutEffect1.stop();
            ingenuity.currentGame.tweens.remove(fadeOutEffect1);

        }, this);
    }

    /**
    * Method hideFGIntroBG to hide FG intro blur background
    */
    private hideFGIntroBG(): void{
        const fadeOutEffect2: ITween = ingenuity.currentGame.add.tween(this.freeGameIntroBlurContainer).to({ alpha: 0 }, 300, Linear.None, true, 0, 0, false);
        fadeOutEffect2.onComplete.addOnce(() => {
        this.freeGameIntroBlurContainer.alpha = 1;
        this.freeGameIntroBlurContainer.visible = false;
            fadeOutEffect2.stop();
            ingenuity.currentGame.tweens.remove(fadeOutEffect2);
        }, this);
    }

    /**
    * Method hideFGOutroBG to hide FG outro blur background
    */
    private hideFGOutroBG(): void{
        const fadeOutEffect3: ITween = ingenuity.currentGame.add.tween(this.freeGameOutroBlurContainer).to({ alpha: 0 }, 300, Linear.None, true, 0, 0, false);
        fadeOutEffect3.onComplete.addOnce(() => {
        this.freeGameOutroBlurContainer.alpha = 1;
        this.freeGameOutroBlurContainer.visible = false;
            fadeOutEffect3.stop();
            ingenuity.currentGame.tweens.remove(fadeOutEffect3);
        }, this);
    }

    /**
    * Method hideGrandJPBG to hide grand jp banner blur background
    */
    private hideGrandJPBG(): void{
        const fadeOutEffect4: ITween = ingenuity.currentGame.add.tween(this.grandJackpotBlurContainer).to({ alpha: 0 }, 500, Linear.None, true, 0, 0, false);
        fadeOutEffect4.onComplete.addOnce(() => {
        this.grandJackpotBlurContainer.alpha = 1;
        this.grandJackpotBlurContainer.visible = false;
            fadeOutEffect4.stop();
            ingenuity.currentGame.tweens.remove(fadeOutEffect4);
        }, this);
    }

    /**
    * Method hideMajorJPBG to hide major jp banner blur background
    */
    private hideMajorJPBG(): void{
        const fadeOutEffect5: ITween = ingenuity.currentGame.add.tween(this.majorJackpotBlurContainer).to({ alpha: 0 }, 500, Linear.None, true, 0, 0, false);
        fadeOutEffect5.onComplete.addOnce(() => {
        this.majorJackpotBlurContainer.alpha = 1;
        this.majorJackpotBlurContainer.visible = false;
            fadeOutEffect5.stop();
            ingenuity.currentGame.tweens.remove(fadeOutEffect5);
        }, this);
    }

    /**
    * Method hideMinorJPBG to hide minor jp banner blur background
    */
    private hideMinorJPBG(): void{
        const fadeOutEffect6: ITween = ingenuity.currentGame.add.tween(this.minorJackpotBlurContainer).to({ alpha: 0 }, 500, Linear.None, true, 0, 0, false);
        fadeOutEffect6.onComplete.addOnce(() => {
        this.minorJackpotBlurContainer.alpha = 1;
        this.minorJackpotBlurContainer.visible = false;
            fadeOutEffect6.stop();
            ingenuity.currentGame.tweens.remove(fadeOutEffect6);
        }, this);
    }

    /**
    * Method hideMiniJPBG to hide mini jp banner blur background
    */
    private hideMiniJPBG(): void{
        const fadeOutEffect7: ITween = ingenuity.currentGame.add.tween(this.miniJackpotBlurContainer).to({ alpha: 0 }, 500, Linear.None, true, 0, 0, false);
        fadeOutEffect7.onComplete.addOnce(() => {
        this.miniJackpotBlurContainer.alpha = 1;
        this.miniJackpotBlurContainer.visible = false;
            fadeOutEffect7.stop();
            ingenuity.currentGame.tweens.remove(fadeOutEffect7);
        }, this);
    }

    /**
    * Method hideRetriggerBG to hide retrigger blur background
    */
    private hideRetriggerBG(): void{
        const fadeOutEffect8: ITween = ingenuity.currentGame.add.tween(this.retriggerBlurContainer).to({ alpha: 0 }, 300, Linear.None, true, 1000, 0, false);
        fadeOutEffect8.onComplete.addOnce(() => {
        this.retriggerBlurContainer.alpha = 1;
        this.retriggerBlurContainer.visible = false;
            fadeOutEffect8.stop();
            ingenuity.currentGame.tweens.remove(fadeOutEffect8);
        }, this);
    }


  // Hide Blur Background with fade out effect
  private hideBlurBgWithFadeOutEffect(): void {
    const popUpBlurBgContainer: Container = this.view.getContainerByID("popUpBlurBgContainer");
    const BlurBgFadeOutTween: ITween = ingenuity.currentGame.add.tween(popUpBlurBgContainer).to({ alpha: 0 },this.blurBgFadeOutDuration,Linear.None,true,0, 0,false);
    BlurBgFadeOutTween.onComplete.addOnce(() => {
      BlurBgFadeOutTween.stop();
      ingenuity.currentGame.tweens.remove(BlurBgFadeOutTween);
      this.view.getImageById("bigWinBlurBg").visible = false;
      this.view.getImageById("superWinBlurBg").visible = false;
      this.view.getImageById("epicWinBlurBg").visible = false;
      this.view.getImageById("crazyWinBlurBg").visible = false;
    }, this);
  }


}
